// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GJqE","top":"styles_top__20dOZ"};